'use client';

import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function PostHogPageView() {
  const location = useLocation();
  const posthog = usePostHog();

  useEffect(() => {
    // Track pageviews
    if (posthog && location.pathname) {
      posthog.capture('$pageview', {
        $current_url: location.pathname,
      });
    }
  }, [location.pathname, posthog, posthog.capture]);

  return null;
}
